module.exports = __webpack_public_path__ + "img/equality.efe05718.png";